import React from "react";
import "./Button.scss";
import { NavLink } from "react-router-dom";

const Button = ({
  children,
  type,
  icon,
  to,
  submit,
  onClick,
  disabled,
  id,
  index,
  ...props
}) => {
  return to ? (
    <NavLink
      to={to}
      activeClassName="active"
      className="Button"
      data-icon={icon}
      data-type={type}
      data-disabled={disabled}
      id={id}
      {...props}
    >
      {children}
    </NavLink>
  ) : (
    <button
      disabled={disabled}
      onClick={onClick}
      className="Button"
      data-icon={icon}
      data-type={type}
      data-index={index}
      id={id}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
